const DependencyType = {
    AttractLoopOrchestratorService: Symbol.for('AttractLoopOrchestratorService'),
}


export default DependencyType;